export const formatAmount = (
    value: FeipApi.Kopecks,
    removeTrailingZeros = false,
    digits = 2,
    separator = ' ',
): string => {
    const formatted = (value / 100)
        .toFixed(digits)
        .replace(/(\d)(?=(\d{3})+(\.|$))/g, `$1${separator}`)
        .replace(/\./g, ',');
    return removeTrailingZeros && value % 100 === 0 ? formatted.replace(/,\d{2}/, '') : formatted;
};

export const formatAmountWithCurrency = (
    value: FeipApi.Kopecks,
    removeTrailingZeros = true,
    digits = 2,
    separator = ' ',
): string => {
    return `${formatAmount(value, removeTrailingZeros, digits, separator)} ₽`;
};
